import React from "react";
import { Col, Row } from "antd";
import { Controller } from "react-hook-form";
import CustomTextfield from "../../../../../../common/input/custom-textfield/custom-textfield";

const MedicalInformation = ({ control }) => {
  return (
    <Row gutter={[32, 20]}>
      <Col span={12}>
        <Controller
          name="allergies"
          control={control}
          render={({
            field: { onChange, value },
            fieldState: { error },
          }) => (
            <CustomTextfield
              id="allergies"
              label="Medical Conditions/Allergies"
              showOptional
              labelColor="#171717"
              placeholder="Enter medical conditions allergies"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="special_needs"
          control={control}
          render={({
            field: { onChange, value },
            fieldState: { error },
          }) => (
            <CustomTextfield
              id="special_needs"
              label="Special Needs/Support Requirements"
              showOptional
              labelColor="#171717"
              placeholder="Enter special needs or support requirements"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>
    </Row>
  );
};

export default MedicalInformation;
